/**
 * App-level UI overrides: theme, icons, and components.
 *
 * Registers the INGKA light theme, custom system icons, and the
 * custom 404 page as native extensions, replacing the legacy
 * `themes`, `icons`, and `components` options from convertLegacyAppOptions.
 *
 * The built-in light/dark themes must be disabled in app-config.yaml:
 *   app:
 *     extensions:
 *       - theme:app/light: false
 *       - theme:app/dark: false
 */
import { PropsWithChildren } from 'react';
import {
  createFrontendModule,
  NotFoundErrorPage,
} from '@backstage/frontend-plugin-api';
import {
  IconBundleBlueprint,
  SwappableComponentBlueprint,
  ThemeBlueprint,
} from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { AllenErrorPage } from '@ingka/allen-core-components';
import { ingkaLight } from '../theme';
import { customSystemIcons } from '../customSystemIcons';

export const appModuleThemeIconsAndComponents = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ThemeBlueprint.make({
      name: 'ingka',
      params: {
        theme: {
          id: 'ingka',
          title: 'Ingka',
          variant: 'light',
          Provider: ({ children }: PropsWithChildren<{}>) => (
            <UnifiedThemeProvider theme={ingkaLight} children={children} />
          ),
        },
      },
    }),
    IconBundleBlueprint.make({
      name: 'allen-icons',
      params: {
        icons: customSystemIcons,
      },
    }),
    SwappableComponentBlueprint.make({
      name: 'not-found-error-page',
      params: define =>
        define({
          component: NotFoundErrorPage,
          loader: () => () => <AllenErrorPage status="404" />,
        }),
    }),
  ],
});
